import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../Vas';
import '../../css/CreateCustomer.css';
import { ExtendedButton,TextField,SelectField,DateField,AutocompleteField,Loading,MessageBox,Checkbox } from 'component-lib';
import { DateTimeHelper,CheckValues } from 'utils-lib';
import { RequestAjaxClass, CustomerModel,StreetsModel, SchoolsModel } from 'models-lib';

var moment = require('moment');
moment().format();

class CreateCustomer extends Component{

    constructor(props)
    {
        super(props);
        this.state = {};
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.CustomerModel = new CustomerModel([this]);
        this.StreetsModel = new StreetsModel([this]);
        this.SchoolsModel = new SchoolsModel([this]);
    }

    componentDidMount(){

        $("#HeaderTitle").html(Vas.Resources.Labels["CreateCustomer"]);

        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler(()=>{
          ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        });

        this.Request2.setApiUrl(Vas.ApiUrl);
        this.Request2.setApiKey(Vas.ApiKey);
        this.Request2.setAuth(true);
        this.Request2.setErrorHandler(()=>{
          ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        });
        
        this.CustomerModel.SetRequest(this.Request);
        this.StreetsModel.SetRequest(this.Request);
        this.SchoolsModel.SetRequest(this.Request2);

        this.setState({ requiredFields:[this.refs.name, this.refs.firstName, this.refs.DateOfBirth,this.refs.zip, this.refs.city, this.refs.street, this.refs.houseNumber,
                        this.refs.schoolPlace],  
                        requiredSelectField:[this.refs.school] },
                        ()=>{
                            for (let i=0; i<this.state.requiredFields.length; i++){
                                this.state.requiredFields[i].setState({ Label:this.state.requiredFields[i].props.Label+"*" });
                            }
                            for (let i=0; i<this.state.requiredSelectField.length; i++){
                                this.state.requiredSelectField[i].setState({ Label:this.state.requiredSelectField[i].props.Label+"*" });
                            }
                        }
                    );
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "CustomersWithSchool"){
          ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
          Vas.GetView("Customers",null,true);
        }
        else if( observer === "Streets"){
          me.refs.street.setState({ Data: this.StreetsModel.Streets, Icon:'' });
          me.setState({ oldZip: this.StreetsModel.PostCode, oldCity: this.StreetsModel.City });
        }
        else if(observer === "Schools"){
          let possibleSchools = [];
          for (let i = 0; i < this.SchoolsModel.Schools.length; i++)
          {
              possibleSchools.push({ Key: this.SchoolsModel.Schools[i].Id, Display: this.SchoolsModel.Schools[i].Name1 });
          }
          me.refs.school.setState({ Data: possibleSchools });
        }
      });
    }

    checkFields(){
        let count;
        if (this.state.requiredFields && this.state.requiredSelectField){
        
            count = this.state.requiredFields.length+this.state.requiredSelectField.length;
            
            let filled = 0;

            for (let i=0;i<this.state.requiredFields.length;i++){
                if (this.state.requiredFields[i]){
                    if (document.getElementById(this.state.requiredFields[i].props.Id).value.length>0){
                        if(!(/^\s+$/).test(document.getElementById(this.state.requiredFields[i].props.Id).value)){
                          filled++;
                        }
                    }
                }
            }
            for (let k=0; k<this.state.requiredSelectField.length;k++){
                if (this.state.requiredSelectField[k]){
                    if (document.getElementById(this.state.requiredSelectField[k].props.Id).selectedIndex >0){
                        filled++;
                    }
                }
            }
   
            if (filled < count){
                let docs=document.querySelectorAll('select,input');
                let docRefs = this.refs;
                CheckValues.checkAllFields(docs,docRefs,"");
                ReactDOM.render(<MessageBox 
                  Message={Vas.Resources.Labels["NotAllFields"]} 
                  Title={Vas.Resources.Titles["Note"]} />,
                    document.getElementById('messageContainer'));
            } else {
                this.createCustomer();
            }
        }
    }

    createCustomer()
    {
        ReactDOM.render(<Loading modal={true} />,document.getElementById('popupContainer'));
        this.refs.Create.setState({ usable:false });
        
        let curDateOfBirth = DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,false,localStorage.getItem('vas_language'));
        this.CustomerModel.Customer.DateOfBirth = moment([curDateOfBirth.year(),curDateOfBirth.month(),curDateOfBirth.date()]).format('YYYY-MM-DD T 00:00:00');
        
        this.CustomerModel.SetCustomerWithSchool($('#school').val());
    }

    getStreets()
    {
        let me = this;
        me.refs.street.setState({ Icon:"Loop" });
        if (this.CustomerModel.Customer.City || this.CustomerModel.Customer.PostCode){
          let place = '';
          let zip = '';

          if ((this.CustomerModel.Customer.PostCode !== me.state.oldZip)||(this.CustomerModel.Customer.City !== me.state.oldCity)){
            me.refs.street.setState({ Data: [], Icon : '' });
            document.getElementById("street").value = '';
          }
          
          if (this.CustomerModel.Customer.City){
            place = this.CustomerModel.Customer.City;
          }
          if (this.CustomerModel.Customer.PostCode){
            zip = this.CustomerModel.Customer.PostCode;
          }
          this.StreetsModel.GetStreets(place,zip);
        } else {
          me.refs.street.setState({ Data: [], Icon : '' });
            document.getElementById("street").value = '';
        }
    }

    getSchools (){
        let me = this;
        this.SchoolsModel.GetSchoolsByCity(me.state.schoolPlace);
    }

    render(){
      let min = moment();
      let minValue = moment([min.year() - Vas.Config.PupilMaxAge, min.month(), min.date() +1]); //minValue für Geburtsdatums Datepicker nicht älter als 18 Jahre
      let maxValue = moment([min.year() - 6, min.month(), min.date()]); //moment(); //maxValue für Geburtsdatums DatePicker max 6 Jahre jung

        return (
          <div className={"form"} >
            <table className="createCustomer">
              <tbody>
                <tr>
                  <td><TextField 
                    AppURL={Vas.ApplicationUrl} 
                    me={this} 
                    Modus={"Name"} 
                    ref={"firstName"} 
                    Id={"Vorname"} 
                    Editable={true} 
                    IsRequired={true} 
                    Float={'left'} 
                    Tooltip={Vas.Resources.Tooltips["Firstname"]} 
                    OnChange={()=>{ this.CustomerModel.Customer.Name2 = $("#Vorname").val(); }} 
                    Label={Vas.Resources.Labels["FirstName"]} 
                    />
                  </td>
                  <td><TextField 
                    AppURL={Vas.ApplicationUrl} 
                    me={this} 
                    Modus={"Name"} 
                    ref={"name"} 
                    Id={"Name"} 
                    Editable={true} 
                    IsRequired={true} 
                    Float={'left'} 
                    Tooltip={Vas.Resources.Tooltips["Name"]} 
                    OnChange={()=>{ this.CustomerModel.Customer.Name1 = $("#Name").val(); }} 
                    Label={Vas.Resources.Labels["Name"]} 
                    />
                  </td>
                </tr>
                <tr>
                  <td><SelectField 
                    AppURL={Vas.ApplicationUrl} 
                    me={this} 
                    ref={"gender"}
                    Id={"Gender"} 
                    Float={'left'} 
                    Label={Vas.Resources.Labels["Gender"]} 
                    IsRequired={false} 
                    Data={[{ Key: 'Männlich', Display: Vas.Resources.Labels["Male"] },{ Key: 'Weiblich', Display: Vas.Resources.Labels["Female"] },{ Key: 'Divers', Display: Vas.Resources.Labels["Divers"] }]} 
                    OnChange={()=>{ this.CustomerModel.Customer.Gender = $("#Gender").val();}} 
                    Tooltip={Vas.Resources.Tooltips["Gender"]} 
                    SelectFieldChooseText={Vas.Resources.Labels["NotSpecified"]}/>
                  </td	>
                  <td ><DateField 
                    AppURL={Vas.ApplicationUrl}
                    Language={localStorage.getItem("vas_language")} 
                    me={this} 
                    ref={"DateOfBirth"} 
                    IsRequired={true} 
                    MaxValue={maxValue}
                    MinValue={minValue} 
                    Editable={true} 
                    Width={170} 
                    Float={'left'} 
                    Id={"DateOfBirth"}  
                    Label={Vas.Resources.Labels["DateOfBirth"]} 
                    Tooltip={Vas.Resources.Tooltips["DateOfBirth"]} 
                    OnBlur={()=>{ this.CustomerModel.Customer.DateOfBirth = $("#DateOfBirth").val();}}
                    FalseMaxDateText={Vas.Resources.Labels["PupilDateOfBirthInvalid"]}
                    FalseMinDateText={Vas.Resources.Labels["PupilDateOfBirthInvalid"]} />
                  </td>
                </tr>
                <tr>
                  <td colSpan="2"><TextField 
                    AppURL={Vas.ApplicationUrl} 
                    me={this} 
                    Width={370} 
                    Id="addressAddition" 
                    Editable={true} 
                    IsRequired={false} 
                    Tooltip={Vas.Resources.Tooltips["AddressAddition"]} 
                    Label={Vas.Resources.Labels["AddressAddition"]} 
                    OnChange={()=>{ this.CustomerModel.Customer.Name3 = $("#addressAddition").val();  }} />
                  </td>
                </tr>
                <tr>
                  <td><TextField 
                    Modus={"Number"} 
                    AppURL={Vas.ApplicationUrl} 
                    me={this} 
                    ref={"zip"} 
                    Editable={true} 
                    IsRequired={true} 
                    Float={'left'} 
                    Id={"Zip"} 
                    Tooltip={Vas.Resources.Tooltips["Zip"]} 
                    OnChange={()=>{ this.CustomerModel.Customer.PostCode = $("#Zip").val(); }} 
                    Label={Vas.Resources.Labels["Zip"]}
                    OnBlur={()=>{this.getStreets();}} />
                  </td>
                  <td><TextField 
                    AppURL={Vas.ApplicationUrl} 
                    me={this} 
                    ref={"city"} 
                    Editable={true} 
                    IsRequired={true} 
                    Float={'left'} 
                    Id={"city"} 
                    Label={Vas.Resources.Labels["Place"]} 
                    Tooltip={Vas.Resources.Tooltips["Place"]} 
                    OnChange={()=>{ this.CustomerModel.Customer.City = $("#city").val();}}  
                    OnBlur={()=>{this.getStreets();}} />
                  </td>                        
                </tr>
                <tr>
                  <td colSpan={2}><AutocompleteField 
                    AppURL={Vas.ApplicationUrl} 
                    TitleMessageFalseStreet={Vas.Resources.Labels["Error"]} 
                    MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]} 
                    me={this} 
                    Width={370} 
                    ref={"street"} 
                    Id={"street"} 
                    Float={'left'} 
                    Modus={"Street"} 
                    editable={true} 
                    IsRequired={true} 
                    Label={Vas.Resources.Labels["Street"]} 
                    OnBlur={()=>{ this.CustomerModel.Customer.Street = $("#street").val(); }} 
                    Tooltip={Vas.Resources.Tooltips["Street"]}
                    TimeOutTime={Vas.TimeOutTime} />
                  </td>
                </tr>
                <tr>
                  <td><TextField 
                    Modus={"Number"} 
                    AppURL={Vas.ApplicationUrl} 
                    me={this} 
                    ref={"houseNumber"} 
                    Editable={true} 
                    IsRequired={true} 
                    Float={'left'} 
                    Id={"HouseNumber"} 
                    OnChange={()=>{ this.CustomerModel.Customer.HouseNumber = $("#HouseNumber").val(); }} 
                    Label={Vas.Resources.Labels["HouseNumber"]} 
                    Tooltip={Vas.Resources.Tooltips["Housenumber"]} />
                  </td>
                  <td><TextField 
                    AppURL={Vas.ApplicationUrl} 
                    me={this} 
                    Id="houseNumberAddition" 
                    Editable={true} 
                    IsRequired={false} 
                    Tooltip={Vas.Resources.Tooltips["HouseNumberAddition"]} 
                    Label={Vas.Resources.Labels["HouseNumberAddition"]} 
                    OnChange={()=>{ this.CustomerModel.Customer.HouseNumberAddition = $("#houseNumberAddition").val(); }} />
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}><TextField 
                    AppURL={Vas.ApplicationUrl} 
                    me={this} 
                    ref={"schoolPlace"} 
                    Width={370} 
                    Editable={true} 
                    IsRequired={true} 
                    Float={'left'} 
                    Id={"SchoolPlace"} 
                    Tooltip={Vas.Resources.Tooltips["SchoolPlace"]} 
                    OnBlur={()=>{ this.setState({ schoolPlace: $("#SchoolPlace").val() },()=>{ this.getSchools();});   }} 
                    Label={Vas.Resources.Labels["SchoolPlace"]} />
                  </td>                       
                </tr> 
                <tr>
                  <td colSpan={2}><SelectField 
                    AppURL={Vas.ApplicationUrl} 
                    me={this} 
                    ref={"school"} 
                    Width={370}  
                    Id={"school"} 
                    Data={this.state.schools} 
                    IsRequired={true} 
                    Float={'left'} 
                    Label={Vas.Resources.Labels["Schools"]} 
                    Tooltip={Vas.Resources.Tooltips["School"]} 
                    OnChange={()=>{ this.setState({ SchoolId: $("#Schools").val() });}} />
                  </td>
                </tr> 
                <tr>
                  <td colSpan={2}>
                    <br /><b id={"MarketingComplienceId"}>{Vas.Resources.Labels["MarketingComplience"]} </b>
                  </td>
                </tr>
                    <tr> 
                      <td colSpan={2}>
                        <Checkbox 
                          ref={"MarketingMail"} 
                          Id={"ceckboxMarketingMail"} 
                          onClick={()=>{ this.CustomerModel.Customer.MarketingEmail = document.getElementById("ceckboxMarketingMail").checked;}} 
                          IsRequired={false} />
                        <label style={{ float:'left' }} htmlFor="cbox">{Vas.Resources.Labels["MarketingMail"]}</label>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <Checkbox 
                          ref={"MarketingPhone"} 
                          Id={"ceckboxMarketingPhone"} 
                          onClick={()=>{ this.CustomerModel.Customer.MarketingPhone = document.getElementById("ceckboxMarketingPhone").checked;}} 
                            IsRequired={false} />
                        <label style={{ float:'left' }} htmlFor="cbox">{Vas.Resources.Labels["MarketingPhone"]}</label>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <Checkbox 
                          ref={"MarketingPost"} 
                          Id={"ceckboxMarketingPost"} 
                          onClick={()=>{ this.CustomerModel.Customer.MarketingPost = document.getElementById("ceckboxMarketingPost").checked;}} 
                          IsRequired={false} />
                        <label style={{ float:'left' }} htmlFor="cbox">{Vas.Resources.Labels["MarketingPost"]}</label>
                      </td>
                    </tr>
                <tr>
                  <td><br /><div style={{ float:'left' }}>{Vas.Resources.Labels["RequiredField"]}</div></td>
                </tr> 
                <tr>
                  <td><br /><ExtendedButton 
                    Usable={true} 
                    ref={"Create"}
                    Text={Vas.Resources.Labels["Create"]} 
                    Float={"left"} 
                    OnClick={()=>{this.checkFields();}} 
                    Width={170} />
                  </td>
                  <td><br /><ExtendedButton 
                    Usable={true} 
                    Text={Vas.Resources.Labels["Cancel"]} 
                    OnClick={()=>{ window.location = "/home"; }} 
                    Width={170} />   
                  </td>
                </tr>
                <tr>
                </tr>
              </tbody>
            </table>
            <br />       
          </div>
        );
    }
}
export default CreateCustomer;
